import { equals, path, prop } from 'ramda';
import AppointmentPage from '../../pages/Appointment/Loadable';
import BrandModelPage from '../../pages/BrandModel/Loadable';
import CallMeBackPage from '../../pages/CallMeBack/Loadable';
import CarDestinationsPage from '../../pages/CarDestinations/Loadable';
import ConfirmationPage from '../../pages/Confirmation/Loadable';
import DeliveryPage from '../../pages/Delivery/Loadable';
import ReferentialHighwayDirectionPage from '../../pages/ReferentialPointOfInterest/ReferentialHighwayDirection/Loadable';
import EligibilityPage from '../../pages/Eligibility/Loadable';
import EndAppointmentPage from '../../pages/EndAppointment/Loadable';
import EndMissionPage from '../../pages/EndMission/Loadable';
import EventsDetailsPage from '../../pages/EventsDetails/Loadable';
import EventsPage from '../../pages/Events/Loadable';
import LandingPage from '../../pages/Landing/Loadable';
import HighwayProcessPage from '../../pages/HighwayProcess/Loadable';
import LocationDetailsPage from '../../pages/LocationDetails/Loadable';
import PrepareMissionPage from '../../pages/PrepareMission/Loadable';
import VehicleLocationPage from '../../pages/VehicleLocation/Loadable';
import SplashScreenPage from '../../pages/SplashScreen/Loadable';
import VoiceExitPage from '../../pages/VoiceExit/Loadable';
import WelcomePage from '../../pages/Welcome/Loadable';
import MilestonePage from '../../pages/Milestone/Loadable';
import HighwayDirectionPage from '../../pages/HighwayDirection/Loadable';
import HighwaySelectionPage from '../../pages/ReferentialPointOfInterest/HighwaySelection/Loadable';
import POILocationPage from '../../pages/ReferentialPointOfInterest/POILocation/POILocation';
import PreviousClaimHandlingPage from '../../pages/PreviousClaimHandling/Loadable';
import FnolAppointmentPage from '../../pages/FnolAppointment/Loadable';
import FnolSituationDetailsPage from '../../pages/FnolSituationDetails/Loadable';
import FnolCircumstancesDetailsPage from '../../pages/FnolCircumstancesDetails/Loadable';
import FnolDamagesPage from '../../pages/FnolDamages/Loadable';
import FnolAccidentStatementPage from '../../pages/FnolAccidentStatement/Loadable';
import FnolThirdPartyInfoPage from '../../pages/FnolThirdPartyInfo/Loadable';
import EndLocationProcess from '../../pages/EndLocationProcess/Loadable';
import AdditionalTransportationPage from '../../pages/AdditionalTransportation/Loadable';
import OTPPage from '../../pages/OTP/Loadable';
import Identification from '../../pages/Identification/Identification';
import RentalCarWelcome from '../../pages/RentalCarWorkflow/RentalCarWelcome/Loadable';
import RentalCarDriverDetails from '../../pages/RentalCarWorkflow/RentalCarDriverDetails/Loadable';
import RentalInformation from '../../pages/RentalCarWorkflow/RentalInformation/Loadable';
import RentalInfoConfirm from '../../pages/RentalCarWorkflow/RentalInfoConfirm/Loadable';
import RentalMissionCancelled from '../../pages/RentalCarWorkflow/RentalInfoConfirm/components/Loadable';
import RentalSummary from '../../pages/RentalCarWorkflow/RentalSummary/Loadable';
import RentalRegistration from '../../pages/RentalCarWorkflow/RentalRegistration/Loadable';
import BenefitSelection from '../../pages/BenefitSelection/Loadable';
// eslint-disable-next-line max-len
import RentalVehicleLocationGarageConfirm from '../../pages/RentalCarWorkflow/RentalVehicleLocation/RentalVehicleLocationGarageConfirm/Loadable';
import RentalVehicleOtherLocation from '../../pages/RentalCarWorkflow/RentalVehicleLocation/RentalVehicleOtherLocation/Loadable';
import RentalVehicleLocationSummary from '../../pages/RentalCarWorkflow/RentalVehicleLocation/RentalVehicleLocationSummary/Loadable';
import RentalEligibility from '../../pages/RentalCarWorkflow/RentalEligibility/Loadable';
import RentalExtensionVehicleLocation from '../../pages/RentalCarWorkflow/RentalExtensionVehicleLocation/Loadable';
import RentalExtensionNotEligible from '../../pages/RentalCarWorkflow/RentalExtensionNotEligible/Loadable';
import RentalExtensionDuration from '../../pages/RentalCarWorkflow/RentalExtensionDuration/Loadable';
import RentalExtensionConfirmation from '../../pages/RentalCarWorkflow/RentalExtensionConfirmation/Loadable';
import OemDecisionPage from '../../pages/OemDecision/Loadable';
import OemTransferredPage from '../../pages/OemTransferred/Loadable';

import {
  callMeBackError,
  carDestinationsInfoWorkflow,
  claimWorkflow,
  confirmationErrorWorkflow,
  errorWorkflow,
  isNotEligibleError,
  missionWorkflow,
  rentalErrorWorkflow,
  rentalExtensionClosedDayExit,
  shouldCallProviderBadClaim
} from './extraWorkflows';
import events from '../events';
import ducks from '../../ducks/ducks';
import states from '../states';
import { SET_ADDITIONAL_SERVICE } from '../../ducks/global';
import { RESEND_SMS } from '../../ducks/eligibility';
import {
  EXTENSION_DURATION_BANK_HOLIDAY,
  EXTENSION_DURATION_WEEKEND,
  RENTAL_AGENCY_CLOSED,
  VEHICLE_GARAGE_LOCATION_CORRECT,
  VEHICLE_LOCATION
} from '../../ducks/rentalMission';

import {
  getPreviousClaimId,
  getMaxRetryCounter,
  getClaim,
  getMissionId,
  getAppointment as getMissionAppointment,
  getNumberOfPassengers,
  getIsClaimNotDisplayed,
  getJwt,
  getIsNonEditableClaim,
  getAllowNoDestinationProcessInDigital,
  getAllowHidingDestinationProcessInDigital,
  getMissionIsInCreation,
  getCoreRentalMission,
  getJwtPhone,
  getBenefit,
  getOemProviderPhone
} from '../../selectors/coreApi';
import { getErrorCode, getClaimAlreadyExists } from '../../selectors/error';
import { getIsUnknownDestination } from '../../selectors/carDestination';
import { getIsExtensionFlow, getRentalVehicleOtherLocationType } from '../../selectors/rentalMission';
import {
  isNewSession,
  isApiSession,
  getProviderArrival,
  getIsHighwayMode,
  getIsLocationOnlyMode,
  getIsGarageDestinationMode,
  getIsMultiChannelMode,
  getIsClaimTimeline,
  isEmbed,
  getSession,
  getIsRentalCarMode
} from '../../selectors/global';
import { getHighway, getIsCountryReferentialHighwayPOIAllowed, getIsCountryHighwaySectionAllowed } from '../../selectors/location';
import { VOICE_EXIT } from '../../services/analytics/tags';
import {
  getAdditionalTransportationQuestion,
  getAppointmentDeactivation,
  getFnolWorkflow,
  getIsPublicApiV4,
  getIsOemWorkflowEnabled
} from '../../selectors/settings';
import { getThirdPartyDetails } from '../../selectors/fnol';

import { getActionsFromDucks } from '../utils';
import {
  hasPossibleDestination,
  isClaimCompleted,
  isCountryFR,
  isDigitalHighwayProcess,
  isEligible,
  isMissionCancelled,
  isMissionEnded,
  isMissionInProgress,
  isMissionMonitoringIsEnded,
  isMissionNotYetDispatched,
  isMissionRejectedOrTimeOut,
  isTOWService,
  shouldFillEventClaim,
  shouldFillLocationClaim,
  shouldFillCarDestination,
  shouldFillAppointment,
  hasMission,
  isROSService,
  shouldPutVehicleDestination,
  isSpecificDestinationsLoaded,
  isRentalMissionCancelled,
  isRentalMissionSummaryAllowed,
  isRentalMissionEnded,
  isRentalMissionRejectedOrTimeOut,
  isRentalMissionInCreation,
  isVehicleImmobilizationOrVehicleDestinationAdded,
  isCoveredForRentalExtension,
  isDigitalRentalWoFirstService,
  isCaptchaJWTExists
} from '../../utils/coreApi';
import { isCscLocationDigitalExit } from '../../utils/rentalMission';
import {
  isRequestError400,
  isRequestError403,
  isRequestError404,
  isRequestError409,
  isClaimFnolMissing,
  isOTPNotValid
} from '../../utils/error';
import { CALL_ME_BACK_COOKIE, getCookie, getRentalRegistrationDone, TERMS_AGREEMENT } from '../../utils/cookies';

import { hasSplashScreen } from '../../utils/settings';
import { isPhoneNumberUpdated } from '../../utils/elegibility';
import {
  APPROVED,
  AUTH_ERROR,
  AUTHENTICATED,
  CAR_DESTINATION_ERROR,
  CAR_DESTINATIONS_INFO_LOADED,
  CLAIM_CREATED,
  CLAIM_LOADED,
  CONFIRMATION_ERROR,
  CONTINUE_PROCESS,
  CREATE_MISSION_ERROR,
  EVENTS_DETAILS_ERROR,
  MISSION_CONFIRMED,
  MISSION_CREATED,
  MISSION_DISPATCHED,
  MISSION_LOADED,
  MISSION_MONITORING_ERROR,
  MISSION_MONITORING_EVENT,
  NO_CLAIM_FOUND,
  NO_MISSION_FOUND,
  PROVIDER_ARRIVAL_ERROR,
  REQUEST_ERROR,
  REQUEST_SUCCESS,
  SESSION_ERROR,
  VEHICLE_LOCATION_ERROR,
  LOCATION_DETAILS_ERROR,
  CANCEL_APPOINTMENT,
  UPDATE_APPOINTMENT,
  CANCEL_MILESTONE,
  CLAIM_PATCHED,
  HIGHWAY_SECTIONS_FOUND,
  CANCEL_HIGHWAY_DIRECTION,
  HIGHWAY_SECTIONS_NOT_FOUND,
  CANCEL_PREVIOUS_CLAIM_HANDLING,
  VEHICLE_INFO_LOADED,
  CLAIM_VEHICLE_LOSS_PUTTED,
  CLAIM_PUTTED,
  MISSION_PUTTED,
  MISSION_CANCELED,
  CLAIM_DIGITAL_EXIT_CREATED,
  JWT_CREATED,
  OTP_REQUESTED,
  MISSIONS_LOADED,
  VIEW_RENTAL_SUMMARY,
  VIEW_TIMELINE,
  RENTAL_MISSION_DISPATCHED,
  RENTAL_MISSION_UPDATED,
  RENTAL_MISSION_CREATED,
  TIMEOUT,
  RENTAL_CLAIM_LOADED,
  ANOTHER_REQUEST,
  RENTAL_BENEFIT_COVERAGE_ISSUE,
  CSC_ELIGIBILE,
  SELECT_BENEFIT,
  IMMOBILISATION_GARAGE_UPDATED,
  RENTAL_MISSION_ALREADY_EXISTS,
  RENTAL_EXTENSION_WORKFLOW,
  PHONE_CONTACT,
  RENTAL_EXTENSION_SENT,
  PRODUCT_CONFIGURATION_LOADED,
  CAPTCHA_JWT_CREATED,
  REQUEST_V2_CAPTCHA_VERIFICATION,
  CONFIRMATION_ERROR_CALL_ASSISTANCE,
  CAPTCHA_JWT_INVALID,
  HIGHWAY_NOT_KNOWN,
  STORE_HIGHWAY_DIRECTIONS,
  STORE_HIGHWAY_POINT_OF_INTERESTS,
  HIGHWAY_POINT_OF_INTEREST_DIGITAL_EXIT,
  HIGHWAY_POINT_OF_INTEREST_NOT_LISTED,
  STORE_HIGHWAYS,
  HIGHWAYS_NOT_FOUND,
  CONFIRM_HIGHWAY_LOCATION_WITHOUT_HIGHWAY_FROM_REFERENTIAL,
  IDENTIFICATION_REQUEST_EXCEEDED,
  OEM_TRANSFERRED
} from '../../ducks/coreApi';
import {
  CAR_DESTINATIONS_TAG,
  EVENTS_TAG,
  VEHICLE_LOCATION_TAG,
  LOCATION_DETAILS_TAG,
  RENTAL_CAR_DRIVER_TAG,
  RENTAL_CAR_DRIVER_UPDATE_TAG,
  RENTAL_CAR_INFORMATION_TAG
} from '../tags';
import { CAPTCHA_ACTIONS, ERROR_CODES, MISSION_STATUS, OEM_DECISION_ACTION, VEHICLE_OTHER_LOCATION } from '../../enums';
import { decodeJWT, jwtExpired } from '../../utils/jwt';

const actions = getActionsFromDucks(ducks);

const computeInitialState = state => {
  const jwt = decodeJWT(getJwt(state));
  if (jwtExpired(jwt) && !getCookie(CALL_ME_BACK_COOKIE)) {
    return states.IDENTIFICATION;
  }
  if (getCookie(CALL_ME_BACK_COOKIE)) {
    return states.CALL_ME_BACK;
  }
  if (getPreviousClaimId(state)) {
    return states.LANDING_CLAIM;
  }
  if (!isNewSession(state) || isEmbed(state)) {
    return states.LANDING_SESSION;
  }
  if (hasSplashScreen(state)) {
    return states.SPLASH_SCREEN;
  }
  return states.WELCOME;
};

const max = 9;

export const mainWorkflow = {
  [states.LANDING_CLAIM]: {
    component: LandingPage,
    meta: { stepper: { max } },
    on: {
      [events.START]: {
        target: states.LANDING_CLAIM,
        actions: [actions.coreApi.authenticate],
      },
      [APPROVED]: {
        target: states.LANDING_CLAIM,
        actions: [actions.coreApi.loadClaimById],
      },
      [AUTHENTICATED]: {
        target: states.LANDING_CLAIM,
        actions: [actions.coreApi.loadClaimById],
      },
      [CLAIM_LOADED]: [
        {
          cond: state => getIsClaimNotDisplayed(state),
          target: states.VOICE_EXIT,
        },
        {
          cond: state => getIsOemWorkflowEnabled(state) && getOemProviderPhone(state),
          target: states.OEM_TRANSFERRED,
        },
        {
          cond: state => isApiSession(state) && getIsHighwayMode(state) && getIsNonEditableClaim(state),
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
        {
          cond: state => isApiSession(state) && getIsMultiChannelMode(state) && getIsNonEditableClaim(state),
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
        // This initiates the whole Mission workflow
        {
          cond: state => isApiSession(state) && getIsGarageDestinationMode(state),
          target: states.LANDING_CLAIM,
          actions: [actions.coreApi.searchMissionByPreviousId],
        },
        {
          cond: state => isApiSession(state) && getIsRentalCarMode(state),
          target: states.LANDING_CLAIM,
          actions: [actions.coreApi.searchMission],
        },
        {
          cond: state => isClaimCompleted(state),
          target: states.LANDING_CLAIM,
          actions: [actions.coreApi.searchMission],
        },
        {
          cond: state => isApiSession(state) && (getIsHighwayMode(state) || getIsLocationOnlyMode(state)),
          target: states.VEHICLE_LOCATION,
        },
        {
          cond: state => isApiSession(state) && getIsMultiChannelMode(state),
          target: states.GDPR,
        },
        {
          cond: state => isApiSession(state) && getIsClaimTimeline(state),
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
        ...claimWorkflow(states.LANDING_CLAIM),
      ],
      [HIGHWAY_SECTIONS_FOUND]: [
        {
          cond: state => isApiSession(state) && getIsClaimTimeline(state),
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
        {
          target: states.HIGHWAY_DIRECTION,
        },
      ],
      [HIGHWAY_SECTIONS_NOT_FOUND]: [...errorWorkflow({}, ERROR_CODES.HIGHWAY_SECTIONS_NON_AVAILABLE)],
      [MISSION_LOADED]: [...missionWorkflow(states.LANDING_CLAIM)],
      [NO_MISSION_FOUND]: [
        {
          cond: state => isApiSession(state) && getIsRentalCarMode(state),
          actions: actions.coreApi.getProductConfiguration,
        },
        {
          cond: state => isApiSession(state) && getIsHighwayMode(state),
          target: states.VEHICLE_LOCATION,
        },
        {
          cond: state => isApiSession(state) && getIsLocationOnlyMode(state),
          target: states.VEHICLE_LOCATION,
        },
        {
          cond: state => isApiSession(state) && getIsGarageDestinationMode(state),
          target: states.CAR_DESTINATIONS,
          actions: [actions.coreApi.loadCarDestinationsInfo],
        },
        {
          cond: state => isApiSession(state) && getIsMultiChannelMode(state),
          target: states.GDPR,
        },
        {
          cond: state => isApiSession(state) && getIsClaimTimeline(state),
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
        {
          target: states.PREVIOUS_CLAIM_HANDLING,
          cond: isMissionNotYetDispatched,
        },
      ],
      [PRODUCT_CONFIGURATION_LOADED]: [
        {
          cond: state =>
            getIsRentalCarMode(state) &&
            !(
              isRentalMissionSummaryAllowed(state) ||
              (isRentalMissionInCreation(state) && isDigitalRentalWoFirstService(state)) ||
              getRentalRegistrationDone(getSession(state))
            ),
          target: states.RENTAL_CAR_WELCOME,
        },
        {
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
      ],
      [MISSIONS_LOADED]: [
        {
          cond: state =>
            isApiSession(state) &&
            getIsRentalCarMode(state) &&
            (!Object.keys(getCoreRentalMission(state)).length || isRentalMissionCancelled(state)),
          actions: actions.coreApi.getProductConfiguration,
        },
        {
          cond: state => isApiSession(state) && getIsRentalCarMode(state) && Object.keys(getCoreRentalMission(state)).length,
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
      ],
      [CAR_DESTINATIONS_INFO_LOADED]: [...carDestinationsInfoWorkflow],
      [REQUEST_ERROR]: [
        {
          cond: state =>
            (isRequestError403(state) && equals(getErrorCode(state), ERROR_CODES.RESOURCE_ACCESS_ISSUE)) ||
            (isRequestError404(state) && equals(getErrorCode(state), ERROR_CODES.CLAIM_NOT_FOUND)),
          target: states.VOICE_EXIT,
        },
        // add if authentificate so call AUTH_ERROR
        {
          cond: state => equals(getErrorCode(state), ERROR_CODES.CLAIM_NOT_FOUND),
          target: states.ELIGIBILITY,
        },
        ...errorWorkflow(CREATE_MISSION_ERROR),
      ],
    },
  },
  [states.LANDING_SESSION]: {
    component: LandingPage,
    meta: { stepper: { max } },
    on: {
      [events.START]: {
        target: states.LANDING_SESSION,
        actions: [actions.coreApi.authenticate],
      },
      [APPROVED]: [
        {
          cond: state => getCookie(TERMS_AGREEMENT) || isEmbed(state),
          target: states.ELIGIBILITY,
        },
        {
          target: states.WELCOME,
        },
      ],
      [AUTHENTICATED]: {
        target: states.VOICE_EXIT,
        actions: [actions.error.setTechnicalError(AUTH_ERROR)],
      },
      [REQUEST_ERROR]: [...errorWorkflow(AUTH_ERROR)],
    },
  },

  [states.SPLASH_SCREEN]: {
    component: SplashScreenPage,
    on: {
      [events.NEXT]: {
        target: states.WELCOME,
      },
    },
  },

  [states.WELCOME]: {
    component: WelcomePage,
    meta: { stepper: { max } },
    on: {
      [events.NEXT]: {
        target: states.WELCOME,
        actions: [actions.coreApi.authenticate],
      },
      [APPROVED]: {
        target: states.ELIGIBILITY,
        actions: [actions.global.setTermsAgreementCookie],
      },
      [AUTHENTICATED]: {
        target: states.VOICE_EXIT,
        actions: [actions.error.setTechnicalError(AUTH_ERROR)],
      },
      [REQUEST_ERROR]: [...errorWorkflow(AUTH_ERROR)],
    },
  },
  [states.ELIGIBILITY]: {
    component: EligibilityPage,
    on: {
      [events.NEXT]: [
        {
          cond: (state, { payload }) => isCaptchaJWTExists() && isPhoneNumberUpdated(state, payload?.phoneNumber),
          target: states.ELIGIBILITY,
          actions: [actions.eligibility.storeData, actions.coreApi.clearJWT, actions.coreApi.requestOTP],
        },
        {
          cond: (state, { payload }) => !isCaptchaJWTExists() && isPhoneNumberUpdated(state, payload?.phoneNumber),
          target: states.ELIGIBILITY,
          actions: [
            actions.eligibility.storeData,
            actions.coreApi.clearJWT,
            actions.coreApi.generateV3CaptchaJwt(CAPTCHA_ACTIONS.REQUEST_OTP),
          ],
        },
        {
          cond: state => !getJwt(state),
          target: states.OTP,
          actions: [actions.eligibility.storeData],
        },
        {
          target: states.ELIGIBILITY,
          actions: [actions.eligibility.storeData, actions.coreApi.loadClaimByPlateNumber],
        },
      ],
      [REQUEST_V2_CAPTCHA_VERIFICATION]: {
        actions: [actions.coreApi.generateV2CaptchaJwt],
      },
      [CAPTCHA_JWT_CREATED]: {
        target: states.ELIGIBILITY,
        actions: [actions.coreApi.requestOTP],
      },
      [OTP_REQUESTED]: states.OTP,
      [CLAIM_LOADED]: [
        {
          cond: state => getIsOemWorkflowEnabled(state) && getOemProviderPhone(state),
          target: states.OEM_TRANSFERRED,
        },
        {
          cond: state => isClaimCompleted(state),
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.searchMission],
          [CAPTCHA_JWT_INVALID]: [
            {
              cond: state => getMaxRetryCounter(state) <= 1,
              target: states.ELIGIBILITY,
              actions: [actions.coreApi.generateV3CaptchaJwt(CAPTCHA_ACTIONS.REQUEST_OTP)],
            },
            {
              target: states.VOICE_EXIT,
            },
          ],
        },
        {
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
      ],
      [HIGHWAY_SECTIONS_FOUND]: states.PREVIOUS_CLAIM_HANDLING,
      [HIGHWAY_SECTIONS_NOT_FOUND]: [...errorWorkflow({}, ERROR_CODES.HIGHWAY_SECTIONS_NON_AVAILABLE)],
      [MISSION_LOADED]: [
        {
          cond: isTOWService,
          actions: [actions.coreApi.loadCarDestinationsInfo],
          target: states.ELIGIBILITY,
        },
        {
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
      ],
      [CAR_DESTINATIONS_INFO_LOADED]: states.PREVIOUS_CLAIM_HANDLING,
      [NO_CLAIM_FOUND]: [
        {
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.createClaim],
        },
      ],
      [NO_MISSION_FOUND]: states.PREVIOUS_CLAIM_HANDLING,
      [CLAIM_CREATED]: {
        target: states.EVENTS,
        actions: [actions.error.clearTechnicalError],
      },
      [CONTINUE_PROCESS]: states.EVENTS,
      [VEHICLE_INFO_LOADED]: states.BRAND_MODEL,
      [REQUEST_ERROR]: [
        {
          cond: isRequestError409,
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.getVehicleInfo],
        },
        {
          cond: state => isRequestError403(state) && getClaimAlreadyExists(state) && getMaxRetryCounter(state) > 1,
          target: states.CALL_ME_BACK,
        },
        {
          target: states.EVENTS,
          cond: state => getMaxRetryCounter(state) > 2,
        },
        {
          cond: state => isRequestError400(state) || isRequestError404(state),
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.retryNotFoundModal],
        },
        {
          cond: state => isRequestError403(state) && getClaimAlreadyExists(state),
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.retryClaimExist],
        },
        {
          cond: isRequestError403,
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.retryExpiredModal],
        },
        ...errorWorkflow(),
      ],
    },
  },

  [states.IDENTIFICATION]: {
    component: Identification,
    on: {
      [events.START]: {
        actions: [actions.coreApi.authenticate],
      },
      [APPROVED]: {
        actions: actions.coreApi.generateV3CaptchaJwt(CAPTCHA_ACTIONS.REQUEST_TOKEN, getJwtPhone),
      },
      [events.NEXT]: {
        actions: [actions.eligibility.storeData, actions.coreApi.requestIdentification],
      },
      [REQUEST_V2_CAPTCHA_VERIFICATION]: {
        actions: [actions.coreApi.generateV2CaptchaJwt],
      },
      [CAPTCHA_JWT_INVALID]: [
        {
          cond: state => getMaxRetryCounter(state) <= 1,
          actions: [actions.coreApi.generateV3CaptchaJwt(CAPTCHA_ACTIONS.REQUEST_TOKEN)],
        },
        {
          target: states.VOICE_EXIT,
        },
      ],
      [JWT_CREATED]: {
        actions: actions.coreApi.refresh,
      },
      [IDENTIFICATION_REQUEST_EXCEEDED]: {
        target: states.CALL_ME_BACK,
        actions: [actions.global.setCallMeBackCookie(ERROR_CODES.VERIFICATION_ERROR)],
      },
    },
  },

  [states.OTP]: {
    component: OTPPage,
    on: {
      [events.NEXT]: [
        {
          cond: isCaptchaJWTExists(),
          target: states.OTP,
          actions: [actions.eligibility.storeData, actions.coreApi.generateJWT],
        },
        {
          cond: !isCaptchaJWTExists(),
          target: states.OTP,
          actions: [actions.eligibility.storeData, actions.coreApi.generateV3CaptchaJwt(CAPTCHA_ACTIONS.REQUEST_TOKEN)],
        },
      ],
      [REQUEST_V2_CAPTCHA_VERIFICATION]: {
        actions: [actions.coreApi.generateV2CaptchaJwt],
      },
      [CAPTCHA_JWT_CREATED]: {
        target: states.OTP,
        actions: [actions.coreApi.generateJWT],
      },
      [CAPTCHA_JWT_INVALID]: [
        {
          cond: state => getMaxRetryCounter(state) <= 1,
          target: states.OTP,
          actions: [actions.coreApi.generateV3CaptchaJwt(CAPTCHA_ACTIONS.REQUEST_TOKEN)],
        },
        {
          target: states.VOICE_EXIT,
        },
      ],
      [events.BACK]: {
        target: states.ELIGIBILITY,
        actions: actions.error.clearTechnicalError,
      },
      [JWT_CREATED]: {
        target: states.OTP,
        actions: actions.coreApi.loadClaimByPlateNumber,
      },
      [RESEND_SMS]: {
        target: states.OTP,
        actions: [actions.eligibility.clearOTP, actions.error.clearTechnicalError, actions.coreApi.requestOTP],
      },
      [CLAIM_LOADED]: [
        {
          cond: state => getIsOemWorkflowEnabled(state) && getOemProviderPhone(state),
          target: states.OEM_TRANSFERRED,
        },
        {
          cond: state => isClaimCompleted(state),
          target: states.OTP,
          actions: [actions.coreApi.searchMission],
        },
        {
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
      ],
      [HIGHWAY_SECTIONS_FOUND]: states.PREVIOUS_CLAIM_HANDLING,
      [HIGHWAY_SECTIONS_NOT_FOUND]: [...errorWorkflow({}, ERROR_CODES.HIGHWAY_SECTIONS_NON_AVAILABLE)],
      [MISSION_LOADED]: [
        {
          cond: isTOWService,
          actions: [actions.coreApi.loadCarDestinationsInfo],
          target: states.OTP,
        },
        {
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
      ],
      [CAR_DESTINATIONS_INFO_LOADED]: states.PREVIOUS_CLAIM_HANDLING,
      [NO_CLAIM_FOUND]: [
        {
          target: states.OTP,
          actions: [actions.coreApi.createClaim],
        },
      ],
      [NO_MISSION_FOUND]: states.PREVIOUS_CLAIM_HANDLING,
      [CLAIM_CREATED]: {
        target: states.EVENTS,
        actions: [actions.error.clearTechnicalError],
      },
      [CONTINUE_PROCESS]: states.EVENTS,
      [VEHICLE_INFO_LOADED]: states.BRAND_MODEL,
      [REQUEST_ERROR]: [
        {
          cond: isRequestError409,
          target: states.OTP,
          actions: [actions.coreApi.getVehicleInfo],
        },
        {
          cond: state => isRequestError400(state) || isRequestError404(state),
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.retryNotFoundModal],
        },
        {
          cond: isOTPNotValid,
          target: states.OTP,
          actions: [actions.eligibility.clearOTP],
        },
        {
          cond: state => isRequestError403(state) && getClaimAlreadyExists(state) && getMaxRetryCounter(state) > 1,
          target: states.CALL_ME_BACK,
        },
        {
          cond: state => isRequestError403(state) && getClaimAlreadyExists(state),
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.retryClaimExist],
        },
        {
          cond: isRequestError403,
          target: states.ELIGIBILITY,
          actions: [actions.coreApi.retryExpiredModal],
        },
        ...errorWorkflow(),
      ],
    },
  },
  [states.PREVIOUS_CLAIM_HANDLING]: {
    component: PreviousClaimHandlingPage,
    on: {
      [events.NEXT]: [
        {
          cond: state => shouldFillEventClaim(getClaim(state)),
          target: states.EVENTS,
        },
        {
          cond: state => shouldFillLocationClaim(getClaim(state)),
          target: states.VEHICLE_LOCATION,
        },
        {
          cond: state => !hasMission(state),
          target: states.PREPARE_MISSION,
        },
        {
          cond: state => isMissionInProgress(state) || isMissionRejectedOrTimeOut(state),
          target: states.MISSION_MONITORING,
          actions: [actions.coreApi.npsEligibilityClaim, actions.coreApi.startMissionMonitoring],
        },
        {
          cond: state => isMissionInProgress(state) || isMissionRejectedOrTimeOut(state),
          target: states.MISSION_MONITORING,
          actions: actions.coreApi.startMissionMonitoring,
        },
        {
          cond: isMissionEnded,
          target: states.END_MISSION,
        },
        {
          cond: isMissionCancelled,
          target: states.CAR_DESTINATIONS,
          actions: [actions.location.storeData, actions.coreApi.putClaimLocation, actions.coreApi.createMission],
        },
        {
          cond: shouldFillCarDestination,
          target: states.CAR_DESTINATIONS,
        },
        {
          cond: shouldFillAppointment,
          target: states.APPOINTMENT,
        },
        {
          target: states.CONFIRMATION,
        },
      ],
      [events.MODIFY]: [
        {
          target: states.PREVIOUS_CLAIM_HANDLING,
          cond: (_, { payload }) => equals(payload, CAR_DESTINATIONS_TAG),
          actions: [
            actions.error.clearTechnicalError,
            actions.carDestination.setTowMissionAsCurrentMission,
            actions.coreApi.loadCarDestinationsInfo,
          ],
        },
      ],
      [VIEW_RENTAL_SUMMARY]: [
        {
          target: states.RENTAL_SUMMARY,
        },
      ],
      [CAR_DESTINATIONS_INFO_LOADED]: [
        {
          target: states.CAR_DESTINATIONS,
        },
      ],
      [RENTAL_BENEFIT_COVERAGE_ISSUE]: [
        {
          target: states.CALL_ME_BACK,
          actions: [actions.coreApi.createClaimDigitalExit(ERROR_CODES.RENTAL_BENEFIT_COVERAGE_ISSUE), actions.error.setTechnicalError()],
        },
      ],
      [RENTAL_MISSION_ALREADY_EXISTS]: [...rentalErrorWorkflow()],
      [CANCEL_PREVIOUS_CLAIM_HANDLING]: [
        {
          target: states.CALL_ME_BACK,
          actions: [
            actions.coreApi.createClaimDigitalExit(ERROR_CODES.CANCEL_PREVIOUS_CLAIM_HANDLING),
            actions.error.setTechnicalError({}),
          ],
        },
      ],
      [ANOTHER_REQUEST]: {
        target: states.BENEFIT_SELECTION,
      },
      [CLAIM_DIGITAL_EXIT_CREATED]: {
        target: states.CALL_ME_BACK,
        actions: actions.error.setTechnicalError({}),
      },
      [VOICE_EXIT]: {
        target: states.VOICE_EXIT,
      },
      [REQUEST_ERROR]: [...errorWorkflow()],
      [RENTAL_EXTENSION_WORKFLOW]: [
        {
          cond: state => isCoveredForRentalExtension(state),
          actions: [actions.rentalMission.setIsExtensionFlow],
          target: states.RENTAL_EXTENSION_VEHICLE_LOCATION,
        },
        {
          target: states.RENTAL_EXTENSION_NOT_ELIGIBLE,
        },
      ],
    },
  },

  [states.BRAND_MODEL]: {
    component: BrandModelPage,
    on: {
      [events.NEXT]: [
        {
          target: states.BRAND_MODEL,
          actions: [actions.eligibility.storeData, actions.coreApi.createClaim],
        },
      ],
      [CLAIM_CREATED]: {
        target: states.EVENTS,
        actions: [actions.error.clearTechnicalError],
      },
      [REQUEST_ERROR]: [...errorWorkflow(AUTH_ERROR)],
    },
  },

  [states.CALL_ME_BACK]: {
    component: CallMeBackPage,
    meta: { stepper: { value: null } },
    on: {
      [REQUEST_SUCCESS]: {
        actions: [actions.global.setCallMeBackCookie()],
      },
      [REQUEST_ERROR]: {
        target: states.VOICE_EXIT,
        actions: [actions.error.setTechnicalError(CONFIRMATION_ERROR)],
      },
    },
  },

  [states.VOICE_EXIT]: {
    component: VoiceExitPage,
    meta: { stepper: { value: null } },
    type: 'final',
  },

  [states.EVENTS]: {
    component: EventsPage,
    meta: { stepper: { value: 1 } },
    on: {
      [events.NEXT]: [
        {
          target: states.EVENTS_DETAILS,
          actions: [actions.diagnosis.setEventValue, actions.coreApi.getProductConfiguration],
          cond: state => isEligible(state),
        },
        {
          target: states.EVENTS_DETAILS,
          actions: [actions.diagnosis.setEventValue],
        },
      ],
    },
  },

  [states.EVENTS_DETAILS]: {
    component: EventsDetailsPage,
    meta: { stepper: { value: 2 } },
    on: {
      [events.NEXT]: [
        {
          cond: state => isEligible(state),
          target: states.EVENTS_DETAILS,
          actions: [actions.diagnosis.storeData, actions.coreApi.putClaimEvent],
        },
        {
          target: states.VEHICLE_LOCATION,
          actions: [actions.diagnosis.storeData],
        },
      ],
      [events.BACK]: states.EVENTS,
      [CLAIM_PATCHED]: states.VEHICLE_LOCATION,
      [CLAIM_PUTTED]: states.VEHICLE_LOCATION,
      [REQUEST_ERROR]: [...errorWorkflow(EVENTS_DETAILS_ERROR)],
    },
  },
  [states.GDPR]: {
    component: WelcomePage,
    on: {
      [events.NEXT]: {
        target: states.VEHICLE_LOCATION,
      },
    },
  },

  [states.VEHICLE_LOCATION]: {
    component: VehicleLocationPage,
    meta: { stepper: { value: 3 } },
    on: {
      [events.NEXT]: [
        {
          cond: state => isEligible(state),
          target: states.LOCATION_DETAILS,
          actions: [actions.location.storeData],
        },
        {
          target: states.LOCATION_DETAILS,
          actions: [actions.location.storeData],
        },
      ],
      [events.BACK]: [
        {
          cond: state => shouldFillEventClaim(getClaim(state)),
          target: states.EVENTS,
        },
        {
          target: states.EVENTS_DETAILS,
        },
      ],
      [CLAIM_PATCHED]: states.LOCATION_DETAILS,
      [REQUEST_ERROR]: [...errorWorkflow(VEHICLE_LOCATION_ERROR)],
    },
  },

  [states.LOCATION_DETAILS]: {
    component: LocationDetailsPage,
    meta: { stepper: { value: 4 } },
    on: {
      [events.NEXT]: [
        {
          cond: (state, { payload }) =>
            (!isEligible(state) && path(['locationDetails', 'highway'])(payload) && getIsCountryReferentialHighwayPOIAllowed(state)) ||
            (payload.highway && getIsCountryReferentialHighwayPOIAllowed(state)),
          target: states.LOCATION_DETAILS,
          actions: [actions.location.storeData, actions.coreApi.fetchHighwaysFromReferential],
        },
        {
          cond: (state, { payload }) =>
            (!isEligible(state) && path(['locationDetails', 'highway'])(payload) && getIsCountryHighwaySectionAllowed(state)) ||
            (payload.highway && getIsCountryHighwaySectionAllowed(state)),
          target: states.MILESTONE,
          actions: [actions.location.storeData],
        },
        {
          cond: state => isApiSession(state) && getIsLocationOnlyMode(state),
          target: states.END_LOCATION,
          actions: [actions.location.storeData, actions.coreApi.putClaimLocation],
        },
        {
          cond: state => isEligible(state),
          target: states.LOCATION_DETAILS,
          actions: [actions.location.storeData, actions.coreApi.putClaimLocation],
        },
        {
          target: states.CONFIRMATION,
          actions: [actions.location.storeData],
        },
      ],
      [events.BACK]: states.VEHICLE_LOCATION,
      [CLAIM_PATCHED]: [
        {
          cond: isDigitalHighwayProcess,
          target: states.MILESTONE,
        },
        { target: states.PREPARE_MISSION },
      ],
      [CLAIM_PUTTED]: states.PREPARE_MISSION,
      [REQUEST_ERROR]: [...errorWorkflow(LOCATION_DETAILS_ERROR)],
      [HIGHWAYS_NOT_FOUND]: states.LOCATION_DETAILS,
      [CONFIRM_HIGHWAY_LOCATION_WITHOUT_HIGHWAY_FROM_REFERENTIAL]: {
        actions: [
          actions.coreApi.createClaimDigitalExit(ERROR_CODES.CUSTOMER_INSISTS_ON_HIGHWAY_LOCATION),
          actions.error.setTechnicalError(),
        ],
        target: states.CALL_ME_BACK,
      },
      [STORE_HIGHWAYS]: {
        target: states.HIGHWAY_SELECTION,
      },
    },
  },

  [states.MILESTONE]: {
    component: MilestonePage,
    meta: { stepper: { value: 5 } },
    on: {
      [events.NEXT]: [
        {
          target: states.MILESTONE,
          actions: [actions.location.storeData, actions.coreApi.getHighwaySections],
        },
      ],
      [events.BACK]: states.LOCATION_DETAILS,
      [CLAIM_PATCHED]: {
        target: states.MILESTONE,
        actions: [actions.coreApi.getHighwaySections],
      },
      [CANCEL_MILESTONE]: [...errorWorkflow({}, ERROR_CODES.CANCEL_MILESTONE)],
      [HIGHWAY_SECTIONS_FOUND]: states.HIGHWAY_DIRECTION,
      [HIGHWAY_SECTIONS_NOT_FOUND]: [...errorWorkflow({}, ERROR_CODES.HIGHWAY_SECTIONS_NON_AVAILABLE)],
      [REQUEST_ERROR]: [...errorWorkflow()],
    },
  },

  [states.HIGHWAY_DIRECTION]: {
    component: HighwayDirectionPage,
    meta: { stepper: { value: 6 } },
    on: {
      [events.NEXT]: [
        {
          cond: state => isApiSession(state) && getIsLocationOnlyMode(state),
          target: states.END_LOCATION,
          actions: [actions.location.storeData, actions.coreApi.putClaimLocation],
        },
        {
          cond: state => isEligible(state),
          target: states.HIGHWAY_DIRECTION,
          actions: [actions.location.storeData, actions.coreApi.putClaimLocation],
        },
        {
          target: states.CONFIRMATION,
          actions: [actions.location.storeData],
        },
      ],
      [events.BACK]: states.MILESTONE,
      [CLAIM_PATCHED]: states.PREPARE_MISSION,
      [CLAIM_PUTTED]: states.PREPARE_MISSION,
      [CANCEL_HIGHWAY_DIRECTION]: [...errorWorkflow({}, ERROR_CODES.CANCEL_HIGHWAY_DIRECTION)],
      [REQUEST_ERROR]: [...errorWorkflow()],
    },
  },

  [states.PREPARE_MISSION]: {
    component: PrepareMissionPage,
    on: {
      [events.NEXT]: [
        {
          cond: state => hasMission(state),
          target: states.PREPARE_MISSION,
          actions: [actions.coreApi.cancelMission],
        },
        {
          target: states.PREPARE_MISSION,
          actions: [actions.coreApi.createMission],
        },
      ],
      [MISSION_CANCELED]: [
        {
          target: states.PREPARE_MISSION,
          actions: [actions.coreApi.createMission],
        },
      ],
      [MISSION_CREATED]: [
        {
          cond: shouldPutVehicleDestination,
          target: states.PREPARE_MISSION,
          actions: actions.coreApi.putVehicleDestination,
        },
        {
          target: states.CAR_DESTINATIONS,
          cond: state => isTOWService(state) && hasPossibleDestination(state),
        },
        {
          target: states.APPOINTMENT,
          cond: state => !getAppointmentDeactivation(state) && !isDigitalHighwayProcess(state),
        },
        {
          target: states.CONFIRMATION,
        },
      ],
      [MISSION_PUTTED]: [
        {
          cond: state =>
            (isTOWService(state) || isROSService(state)) &&
            hasPossibleDestination(state) &&
            !getAllowHidingDestinationProcessInDigital(state),
          target: states.CAR_DESTINATIONS,
        },
        {
          target: states.APPOINTMENT,
          cond: state => !getAppointmentDeactivation(state) && !isDigitalHighwayProcess(state),
        },
        {
          target: states.CONFIRMATION,
        },
      ],
      [REQUEST_ERROR]: [
        {
          cond: state => equals(getErrorCode(state), ERROR_CODES.CLAIM_WARRANTY_ISSUE) && getIsOemWorkflowEnabled(state),
          target: states.OEM_DECISION,
          actions: [actions.error.clearTechnicalError],
        },
        {
          target: states.CONFIRMATION,
        },
      ],
    },
  },

  [states.CAR_DESTINATIONS]: {
    component: CarDestinationsPage,
    meta: { stepper: { value: 7 } },
    on: {
      [events.NEXT]: [
        {
          cond: (state, { payload }) => prop('isUnknownDestination', payload) && !getAllowNoDestinationProcessInDigital(state),
          target: states.CONFIRMATION,
          actions: [actions.carDestination.storeData, actions.coreApi.clearVehicleDestinationValues],
        },
        {
          cond: (state, { payload }) => prop('isUnknownDestination', payload) && getAllowNoDestinationProcessInDigital(state),
          target: states.APPOINTMENT,
          actions: [actions.carDestination.storeData, actions.coreApi.clearVehicleDestinationValues, actions.coreApi.putVehicleDestination],
        },
        {
          cond: state => !getMissionIsInCreation(state) && getIsGarageDestinationMode(state),
          target: states.CONFIRMATION,
          actions: [actions.carDestination.storeData, actions.carDestination.storeCarDestinationInMission],
        },
        {
          cond: state => !getMissionIsInCreation(state),
          target: states.CAR_DESTINATIONS,
          actions: [actions.carDestination.storeData, actions.coreApi.updateMission],
        },
        {
          target: states.CAR_DESTINATIONS,
          actions: [actions.carDestination.storeData, actions.coreApi.putVehicleDestination],
        },
      ],
      [MISSION_PUTTED]: [
        {
          cond: state => !getMissionIsInCreation(state),
          target: states.PREVIOUS_CLAIM_HANDLING,
          actions: [actions.coreApi.searchMission],
        },
        {
          cond: state =>
            !getIsGarageDestinationMode(state) &&
            !getAppointmentDeactivation(state) &&
            !isDigitalHighwayProcess(state) &&
            isSpecificDestinationsLoaded(state),
          target: states.APPOINTMENT,
        },
        {
          cond: state => isSpecificDestinationsLoaded(state),
          target: states.CONFIRMATION,
        },
      ],
      [REQUEST_ERROR]: [
        {
          cond: state => !getMissionIsInCreation(state),
          target: states.PREVIOUS_CLAIM_HANDLING,
          actions: [actions.coreApi.searchMission],
        },
        {
          target: states.CONFIRMATION,
        },
      ],
      [SESSION_ERROR]: states.ELIGIBILITY,
    },
  },

  [states.APPOINTMENT]: {
    component: AppointmentPage,
    meta: { stepper: { value: 8 } },
    on: {
      [events.NEXT]: [
        {
          target: states.APPOINTMENT,
          actions: [actions.appointment.storeData, actions.coreApi.updateMissionType],
        },
      ],
      [REQUEST_SUCCESS]: [
        {
          target: states.CONFIRMATION,
          actions: [actions.coreApi.loadCarDestinationsInfo],
        },
      ],
      [REQUEST_ERROR]: [...errorWorkflow(CAR_DESTINATION_ERROR)],
    },
  },

  [states.CONFIRMATION]: {
    component: ConfirmationPage,
    meta: { stepper: { value: 9 } },
    on: {
      [events.NEXT]: [
        callMeBackError(
          state => isNotEligibleError(state) && shouldCallProviderBadClaim(state),
          [actions.error.setTechnicalError(CONFIRMATION_ERROR_CALL_ASSISTANCE)]
        ),
        callMeBackError(
          state => isNotEligibleError(state),
          [actions.coreApi.digitalInteractions, actions.error.setTechnicalError(CONFIRMATION_ERROR)]
        ),
        {
          cond: state => isCountryFR(state) && getHighway(state),
          target: states.HIGHWAY_PROCESS,
        },
        ...confirmationErrorWorkflow(),
        {
          cond: state =>
            getAdditionalTransportationQuestion(state) && isEligible(state) && isTOWService(state) && getNumberOfPassengers(state) > 2,
          target: states.ADDITIONAL_TRANSPORTATION,
        },
        {
          cond: state => !getMissionIsInCreation(state) && isEligible(state) && !getIsUnknownDestination(state),
          target: states.CONFIRMATION,
          actions: [actions.coreApi.updateMission],
        },
        {
          cond: state => isEligible(state) && !getIsUnknownDestination(state),
          target: states.CONFIRMATION,
          actions: [actions.coreApi.dispatchMission],
        },
      ],
      [CLAIM_VEHICLE_LOSS_PUTTED]: [
        {
          target: states.CONFIRMATION,
          actions: [actions.coreApi.dispatchMission],
        },
      ],
      [MISSION_DISPATCHED]: [
        {
          cond: state => getMissionAppointment(state),
          target: states.END_APPOINTMENT,
        },
        {
          cond: getIsPublicApiV4,
          target: states.MISSION_MONITORING,
          actions: [actions.coreApi.npsEligibilityClaim, actions.coreApi.startMissionMonitoring],
        },
        {
          target: states.MISSION_MONITORING,
          actions: actions.coreApi.startMissionMonitoring,
        },
      ],
      [events.MODIFY]: [
        {
          target: states.VEHICLE_LOCATION,
          cond: (_, { payload }) => equals(payload, VEHICLE_LOCATION_TAG),
          actions: [actions.error.clearTechnicalError, actions.location.resetHighwayLocationValues],
        },
        {
          target: states.EVENTS,
          cond: (_, { payload }) => equals(payload, EVENTS_TAG),
          actions: actions.error.clearTechnicalError,
        },
        {
          target: states.LOCATION_DETAILS,
          cond: (_, { payload }) => equals(payload, LOCATION_DETAILS_TAG),
          actions: actions.error.clearTechnicalError,
        },
        {
          target: states.CAR_DESTINATIONS,
          cond: (_, { payload }) => equals(payload, CAR_DESTINATIONS_TAG),
          actions: actions.error.clearTechnicalError,
        },
      ],
      [events.END]: states.PREVIOUS_CLAIM_HANDLING,
      [MISSION_CONFIRMED]: states.CAR_DESTINATIONS,
      [SESSION_ERROR]: states.ELIGIBILITY,
      [REQUEST_ERROR]: [
        {
          cond: state => isClaimFnolMissing(state) && getFnolWorkflow(state),
          target: states.FNOL_APPOINTMENT,
        },
        {
          cond: isClaimFnolMissing,
          actions: [actions.coreApi.putClaimVehicleLoss],
          target: states.CONFIRMATION,
        },
        ...errorWorkflow(CONFIRMATION_ERROR, null, states.CONFIRMATION),
      ],
    },
  },

  [states.ADDITIONAL_TRANSPORTATION]: {
    component: AdditionalTransportationPage,
    meta: { stepper: { value: null } },
    on: {
      [events.NEXT]: [
        {
          cond: (_, event) => event?.payload?.additionalTransportation,
          target: states.ADDITIONAL_TRANSPORTATION,
          actions: [actions.coreApi.createClaimDigitalExit(ERROR_CODES.ADDITIONAL_TRANSPORTATION_NEEDED)],
        },
        {
          cond: (_, event) => !event?.payload?.additionalTransportation,
          target: states.ADDITIONAL_TRANSPORTATION,
          actions: [actions.coreApi.dispatchMission],
        },
      ],
      [CLAIM_DIGITAL_EXIT_CREATED]: {
        target: states.ADDITIONAL_TRANSPORTATION,
        actions: [actions.coreApi.dispatchMission],
      },
      [MISSION_DISPATCHED]: [
        {
          cond: getMissionAppointment,
          target: states.END_APPOINTMENT,
        },
        {
          target: states.MISSION_MONITORING,
          actions: [actions.coreApi.startMissionMonitoring],
        },
      ],
      [REQUEST_ERROR]: [
        {
          cond: state => isClaimFnolMissing(state) && getFnolWorkflow(state),
          target: states.FNOL_APPOINTMENT,
        },
        ...errorWorkflow(),
      ],
    },
  },

  [states.FNOL_APPOINTMENT]: {
    component: FnolAppointmentPage,
    meta: { stepper: { value: null } },
    on: {
      [events.NEXT]: [
        {
          cond: (_, event) => path(['payload', 'dueDate'])(event),
          actions: [actions.fnol.storeData, actions.coreApi.putClaimVehicleLoss],
          target: states.FNOL_APPOINTMENT,
        },
        {
          actions: [actions.fnol.storeData],
          target: states.FNOL_SITUATION_DETAILS,
        },
      ],
      [CLAIM_VEHICLE_LOSS_PUTTED]: [
        {
          target: states.FNOL_APPOINTMENT,
          actions: [actions.coreApi.dispatchMission],
        },
      ],
      [MISSION_DISPATCHED]: [
        {
          cond: getMissionAppointment,
          target: states.END_APPOINTMENT,
        },
        {
          target: states.MISSION_MONITORING,
          actions: [actions.coreApi.startMissionMonitoring],
        },
      ],
      [REQUEST_ERROR]: [...errorWorkflow()],
    },
  },

  [states.FNOL_SITUATION_DETAILS]: {
    component: FnolSituationDetailsPage,
    meta: { stepper: { value: null } },
    on: {
      [events.NEXT]: [
        {
          cond: (_, event) => path(['payload', 'customerDetails', 'vehicleDamage', 'type'])(event) === 'YES',
          actions: [actions.fnol.storeData],
          target: states.FNOL_DAMAGES,
        },
        {
          cond: (_, event) => path(['payload', 'thirdPartyDetails'])(event),
          actions: [actions.fnol.storeData],
          target: states.FNOL_ACCIDENT_STATEMENT,
        },
        {
          actions: [actions.fnol.storeData],
          target: states.FNOL_CIRCUMSTANCES_DETAILS,
        },
      ],
    },
  },

  [states.FNOL_CIRCUMSTANCES_DETAILS]: {
    component: FnolCircumstancesDetailsPage,
    meta: { stepper: { value: null } },
    on: {
      [events.NEXT]: [
        {
          actions: [actions.fnol.storeCircumstancesDetails, actions.coreApi.putClaimVehicleLoss],
          target: states.FNOL_CIRCUMSTANCES_DETAILS,
        },
      ],
      [CLAIM_VEHICLE_LOSS_PUTTED]: [
        {
          target: states.FNOL_CIRCUMSTANCES_DETAILS,
          actions: [actions.coreApi.dispatchMission],
        },
      ],
      [MISSION_DISPATCHED]: [
        {
          cond: getMissionAppointment,
          target: states.END_APPOINTMENT,
        },
        {
          target: states.MISSION_MONITORING,
          actions: [actions.coreApi.startMissionMonitoring],
        },
      ],
      [REQUEST_ERROR]: [...errorWorkflow()],
    },
  },

  [states.FNOL_DAMAGES]: {
    component: FnolDamagesPage,
    meta: { stepper: { value: null } },
    on: {
      [events.NEXT]: [
        {
          cond: getThirdPartyDetails,
          actions: [actions.fnol.storeVehicleDamage],
          target: states.FNOL_ACCIDENT_STATEMENT,
        },
        {
          actions: [actions.fnol.storeVehicleDamage],
          target: states.FNOL_CIRCUMSTANCES_DETAILS,
        },
      ],
    },
  },

  [states.FNOL_ACCIDENT_STATEMENT]: {
    component: FnolAccidentStatementPage,
    meta: { stepper: { value: null } },
    on: {
      [events.NEXT]: [
        {
          actions: [actions.fnol.storeThirdPartyDetails],
          target: states.FNOL_THIRD_PARTY_INFO,
        },
      ],
    },
  },

  [states.FNOL_THIRD_PARTY_INFO]: {
    component: FnolThirdPartyInfoPage,
    meta: { stepper: { value: null } },
    on: {
      [events.NEXT]: [
        {
          actions: [actions.fnol.storeThirdPartyDetails],
          target: states.FNOL_CIRCUMSTANCES_DETAILS,
        },
      ],
    },
  },

  [states.HIGHWAY_PROCESS]: {
    component: HighwayProcessPage,
    meta: { stepper: { value: null } },
  },

  [states.MISSION_MONITORING]: {
    component: DeliveryPage,
    meta: { stepper: { value: null }, spinnerDeactivated: true },
    on: {
      [events.NEXT]: [
        {
          cond: state => !getProviderArrival(state) && getMissionId(state),
          target: states.CALL_ME_BACK,
          actions: [
            actions.coreApi.createMissionDigitalExit(ERROR_CODES.PROVIDER_NOT_ON_SPOT),
            actions.error.setTechnicalError(PROVIDER_ARRIVAL_ERROR),
          ],
        },
        {
          target: states.END_MISSION,
          actions: [actions.coreApi.endMissionMonitoring],
        },
      ],
      [MISSION_CANCELED]: states.PREVIOUS_CLAIM_HANDLING,
      [VIEW_TIMELINE]: {
        actions: [actions.coreApi.loadClaimById, actions.coreApi.searchMission],
        target: states.PREVIOUS_CLAIM_HANDLING,
      },
      [MISSION_MONITORING_EVENT]: [
        {
          target: states.CALL_ME_BACK,
          cond: isMissionCancelled,
          actions: [actions.error.setTechnicalError(MISSION_MONITORING_ERROR)],
        },
        {
          target: states.MISSION_MONITORING,
          cond: isMissionRejectedOrTimeOut,
          actions: [actions.coreApi.clearMissionMonitoring],
        },
        {
          target: states.PROVIDER_ARRIVAL,
          cond: isMissionMonitoringIsEnded,
          actions: [actions.coreApi.endMissionMonitoring],
        },
      ],
    },
  },

  [states.HIGHWAY_SELECTION]: {
    meta: { stepper: { value: 5 } },
    component: HighwaySelectionPage,
    on: {
      [events.NEXT]: {
        target: states.HIGHWAY_SELECTION,
        actions: [actions.location.storeReferentialHighway, actions.coreApi.fetchHighwayDirectionsFromReferential],
      },
      [events.BACK]: {
        target: states.LOCATION_DETAILS,
      },
      [STORE_HIGHWAY_DIRECTIONS]: {
        target: states.REFERENTIAL_HIGHWAY_DIRECTION,
      },
      [HIGHWAY_NOT_KNOWN]: {
        actions: [
          actions.coreApi.createClaimDigitalExit(ERROR_CODES.CUSTOMER_DOES_NOT_KNOW_THE_HIGHWAY),
          actions.error.setTechnicalError(),
        ],
        target: states.CALL_ME_BACK,
      },
    },
  },

  [states.REFERENTIAL_HIGHWAY_DIRECTION]: {
    meta: { stepper: { value: 6 } },
    component: ReferentialHighwayDirectionPage,
    on: {
      [events.NEXT]: {
        actions: [actions.location.storeHighwayDirection, actions.coreApi.fetchHighwayPOIsFromReferential],
      },
      [events.BACK]: {
        target: states.HIGHWAY_SELECTION,
      },
      [STORE_HIGHWAY_POINT_OF_INTERESTS]: {
        target: states.POI_LOCATION,
      },
    },
  },

  [states.POI_LOCATION]: {
    component: POILocationPage,
    meta: { stepper: { value: 7 } },
    on: {
      [events.NEXT]: [
        {
          cond: state => isApiSession(state) && getIsLocationOnlyMode(state),
          target: states.END_LOCATION,
          actions: [actions.location.storeHighwayPointOfInterest, actions.coreApi.putClaimLocation],
        },
        {
          target: states.POI_LOCATION,
          actions: [actions.location.storeHighwayPointOfInterest, actions.coreApi.putClaimLocation],
        },
      ],
      [events.BACK]: states.REFERENTIAL_HIGHWAY_DIRECTION,
      [HIGHWAY_POINT_OF_INTEREST_DIGITAL_EXIT]: {
        actions: [
          actions.coreApi.createClaimDigitalExit(ERROR_CODES.HIGHWAY_POINT_OF_INTEREST_SHOULD_EXIT),
          actions.error.setTechnicalError(),
        ],
        target: states.CALL_ME_BACK,
      },
      [HIGHWAY_POINT_OF_INTEREST_NOT_LISTED]: {
        actions: [
          actions.coreApi.createClaimDigitalExit(ERROR_CODES.MISSING_POINT_OF_INTEREST_INFORMATION),
          actions.error.setTechnicalError(),
        ],
        target: states.CALL_ME_BACK,
      },
      [CLAIM_PUTTED]: states.PREPARE_MISSION,
    },
  },

  [states.BENEFIT_SELECTION]: {
    component: BenefitSelection,
    on: {
      [events.NEXT]: {
        actions: actions.coreApi.storeSelectedBenefit,
      },
      [SELECT_BENEFIT]: {
        actions: actions.coreApi.checkCscEligibility,
      },
      [CSC_ELIGIBILE]: {
        actions: actions.coreApi.createRentalMission,
      },
      [RENTAL_MISSION_CREATED]: [
        {
          cond: state => isVehicleImmobilizationOrVehicleDestinationAdded(state),
          target: states.RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM,
          actions: [actions.coreApi.clearSelectedBenefit],
        },
        {
          target: states.RENTAL_VEHICLE_OTHER_LOCATION,
          actions: [actions.coreApi.clearSelectedBenefit],
        },
      ],
      [REQUEST_ERROR]: [
        {
          cond: state => equals(getErrorCode(state), ERROR_CODES.CLAIM_WARRANTY_ISSUE) && getIsOemWorkflowEnabled(state),
          target: states.OEM_DECISION,
          actions: [actions.error.clearTechnicalError],
        },
        {
          cond: state => equals(getErrorCode(state), ERROR_CODES.RENTAL_DURATION_LIMIT_EXCEEDED),
          target: states.CALL_ME_BACK,
          actions: [
            actions.coreApi.createClaimDigitalExit(ERROR_CODES.RENTAL_DURATION_LIMIT_EXCEEDED),
            actions.error.setTechnicalError(PHONE_CONTACT),
          ],
        },
        {
          cond: state => equals(getErrorCode(state), ERROR_CODES.BO_CSC_BENEFIT_COVERAGE_ISSUE),
          target: states.CALL_ME_BACK,
          actions: [actions.coreApi.createClaimDigitalExit(ERROR_CODES.BO_CSC_BENEFIT_COVERAGE_ISSUE), actions.error.setTechnicalError()],
        },
        {
          cond: state => getErrorCode(state),
          target: states.CALL_ME_BACK,
          actions: [actions.coreApi.createClaimDigitalExit(ERROR_CODES.RENTAL_BENEFIT_COVERAGE_ISSUE), actions.error.setTechnicalError()],
        },
      ],
    },
  },

  [states.RENTAL_CAR_WELCOME]: {
    component: RentalCarWelcome,
    on: {
      [events.NEXT]: {
        target: states.RENTAL_REGISTRATION,
      },
    },
  },

  [states.RENTAL_REGISTRATION]: {
    component: RentalRegistration,
    on: {
      [events.NEXT]: {
        actions: [
          actions.rentalMission.storeRegistrationData,
          actions.rentalMission.loadClaim,
          actions.rentalMission.setRentalRegistrationDone,
        ],
      },
      [NO_CLAIM_FOUND]: {
        actions: actions.coreApi.retryNotFoundModal,
      },
      [RENTAL_CLAIM_LOADED]: {
        target: states.BENEFIT_SELECTION,
        actions: actions.coreApi.getClaimOperation,
      },
      [REQUEST_ERROR]: [
        {
          cond: state => isRequestError403(state),
          actions: actions.coreApi.retryClaimExist,
        },
        ...rentalErrorWorkflow(),
      ],
    },
  },

  [states.RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM]: {
    component: RentalVehicleLocationGarageConfirm,
    on: {
      [events.NEXT]: [
        {
          target: states.RENTAL_VEHICLE_OTHER_LOCATION,
        },
      ],
      [VEHICLE_GARAGE_LOCATION_CORRECT]: [
        {
          target: states.RENTAL_ELIGIBILITY,
        },
      ],
    },
  },

  [states.RENTAL_VEHICLE_OTHER_LOCATION]: {
    component: RentalVehicleOtherLocation,
    on: {
      [events.NEXT]: {
        actions: [actions.rentalMission.storeVehicleLocation],
      },
      [VEHICLE_LOCATION]: [
        {
          // Extension flow - Already Repaired
          cond: state => getIsExtensionFlow(state) && getRentalVehicleOtherLocationType(state) === VEHICLE_OTHER_LOCATION.ALREADY_REPAIRED,
          actions: [actions.coreApi.updateRentalExtensionInfo({ isEligibleForExtension: false })],
          target: states.RENTAL_EXTENSION_NOT_ELIGIBLE,
        },
        {
          cond: state => isCscLocationDigitalExit(state),
          actions: [actions.coreApi.createClaimDigitalExit(ERROR_CODES.BO_CSC_BENEFIT_COVERAGE_ISSUE), actions.error.setTechnicalError],
          target: states.CALL_ME_BACK,
        },
        {
          cond: state => getRentalVehicleOtherLocationType(state) === VEHICLE_OTHER_LOCATION.OTHER,
          target: states.RENTAL_ELIGIBILITY,
        },
        {
          cond: state => !isCscLocationDigitalExit(state),
          target: states.RENTAL_VEHICLE_LOCATION_SUMMARY,
        },
      ],
      [events.BACK]: [
        {
          // Extension flow
          cond: state => getIsExtensionFlow(state),
          target: states.RENTAL_EXTENSION_VEHICLE_LOCATION,
        },
        {
          target: states.RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM,
        },
      ],
    },
  },

  [states.RENTAL_VEHICLE_LOCATION_SUMMARY]: {
    component: RentalVehicleLocationSummary,
    on: {
      [events.NEXT]: {
        actions: actions.coreApi.updateImmobilizationGarage,
      },
      [IMMOBILISATION_GARAGE_UPDATED]: [
        {
          // Extension flow
          cond: state => getIsExtensionFlow(state),
          target: states.RENTAL_EXTENSION_DURATION,
        },
        {
          target: states.RENTAL_ELIGIBILITY,
        },
      ],
      [events.BACK]: {
        target: states.RENTAL_VEHICLE_OTHER_LOCATION,
      },
      [REQUEST_ERROR]: [
        {
          target: states.CALL_ME_BACK,
          actions: [actions.coreApi.createClaimDigitalExit(ERROR_CODES.RENTAL_BENEFIT_COVERAGE_ISSUE), actions.error.setTechnicalError()],
        },
      ],
    },
  },

  [states.RENTAL_ELIGIBILITY]: {
    component: RentalEligibility,
    on: {
      [events.NEXT]: {
        target: states.RENTAL_CAR_DRIVER_DETAILS,
      },
      [events.END]: {
        actions: [actions.coreApi.loadClaimById, actions.coreApi.searchMission],
        target: states.PREVIOUS_CLAIM_HANDLING,
      },
    },
  },

  [states.RENTAL_CAR_DRIVER_DETAILS]: {
    component: RentalCarDriverDetails,
    on: {
      [events.NEXT]: [
        {
          cond: (_, { payload }) => equals(payload?.key, RENTAL_CAR_DRIVER_TAG),
          actions: [actions.rentalMission.storeRentalDriver],
          target: states.RENTAL_INFORMATION,
        },
        {
          cond: (_, { payload }) => equals(payload?.key, RENTAL_CAR_DRIVER_UPDATE_TAG),
          actions: [actions.rentalMission.storeRentalDriver],
          target: states.RENTAL_CAR_CONFIRM_INFORMATION,
        },
      ],
    },
  },

  [states.RENTAL_INFORMATION]: {
    component: RentalInformation,
    on: {
      [events.NEXT]: {
        actions: [actions.rentalMission.storeVehicleInformation],
        target: states.RENTAL_CAR_CONFIRM_INFORMATION,
      },
      [events.BACK]: {
        target: states.RENTAL_CAR_DRIVER_DETAILS,
      },
    },
  },

  [states.RENTAL_CAR_CONFIRM_INFORMATION]: {
    component: RentalInfoConfirm,
    on: {
      [events.NEXT]: {
        actions: [actions.coreApi.updateRentalMission],
      },
      [events.END]: {
        target: states.RENTAL_CAR_MISSION_CANCELLED_SUCCESSFULLY,
      },
      [RENTAL_MISSION_UPDATED]: {
        actions: [actions.coreApi.dispatchRentalMission],
      },
      [RENTAL_MISSION_DISPATCHED]: {
        actions: [actions.coreApi.searchMission],
      },
      [REQUEST_ERROR]: {
        cond: state => getErrorCode(state),
        target: states.CALL_ME_BACK,
        actions: [
          actions.coreApi.createRentalMissionDigitalExit(ERROR_CODES.RENTAL_CAR_BENEFITS_NOT_COVERED),
          actions.error.setTechnicalError,
        ],
      },
      [MISSIONS_LOADED]: [
        {
          cond: state =>
            getCoreRentalMission(state).status === MISSION_STATUS.PENDING || getCoreRentalMission(state).status === MISSION_STATUS.ACCEPTED,
          target: states.RENTAL_SUMMARY,
        },
        {
          target: states.CALL_ME_BACK,
        },
      ],
      [events.MODIFY]: [
        {
          target: states.RENTAL_CAR_DRIVER_DETAILS,
          cond: (_, { payload }) => equals(payload, RENTAL_CAR_DRIVER_TAG),
          actions: [actions.error.clearTechnicalError],
        },
        {
          target: states.RENTAL_INFORMATION,
          cond: (_, { payload }) => equals(payload, RENTAL_CAR_INFORMATION_TAG),
          actions: [actions.error.clearTechnicalError],
        },
      ],
    },
  },

  [states.RENTAL_CAR_MISSION_CANCELLED_SUCCESSFULLY]: {
    component: RentalMissionCancelled,
    on: {
      [VIEW_TIMELINE]: {
        actions: [actions.coreApi.loadClaimById, actions.coreApi.searchMission],
        target: states.PREVIOUS_CLAIM_HANDLING,
      },
    },
  },

  [states.RENTAL_SUMMARY]: {
    component: RentalSummary,
    on: {
      [events.START]: {
        actions: [actions.coreApi.startMissionMonitoring],
      },
      [events.END]: {
        actions: [actions.coreApi.endMissionMonitoring],
      },
      [MISSION_MONITORING_EVENT]: [
        {
          cond: isRentalMissionRejectedOrTimeOut,
          actions: [actions.coreApi.searchMission, actions.coreApi.endMissionMonitoring],
        },
        {
          cond: isRentalMissionCancelled,
          actions: [actions.error.setTechnicalError(MISSION_MONITORING_ERROR)],
          target: states.CALL_ME_BACK,
        },
        {
          cond: isRentalMissionEnded,
          actions: [actions.coreApi.searchMission],
          target: states.PREVIOUS_CLAIM_HANDLING,
        },
        {
          cond: state => !(isRentalMissionSummaryAllowed(state) || isRentalMissionInCreation(state)),
          actions: [actions.error.setTechnicalError(MISSION_MONITORING_ERROR)],
          target: states.CALL_ME_BACK,
        },
      ],
      [RENTAL_EXTENSION_WORKFLOW]: [
        {
          cond: state => isCoveredForRentalExtension(state),
          actions: [actions.rentalMission.setIsExtensionFlow],
          target: states.RENTAL_EXTENSION_VEHICLE_LOCATION,
        },
        {
          target: states.RENTAL_EXTENSION_NOT_ELIGIBLE,
        },
      ],
      [VIEW_TIMELINE]: {
        actions: [actions.coreApi.loadClaimById, actions.coreApi.searchMission],
        target: states.PREVIOUS_CLAIM_HANDLING,
      },
      [TIMEOUT]: {
        actions: [actions.error.setTechnicalError(MISSION_MONITORING_ERROR)],
        target: states.CALL_ME_BACK,
      },
    },
  },

  [states.END_APPOINTMENT]: {
    component: EndAppointmentPage,
    on: {
      [CANCEL_APPOINTMENT]: [...errorWorkflow({}, ERROR_CODES.CANCEL_APPOINTMENT)],
      [UPDATE_APPOINTMENT]: [...errorWorkflow({}, ERROR_CODES.UPDATE_APPOINTMENT)],
    },
  },

  [states.END_MISSION]: {
    component: EndMissionPage,
    on: {
      [SET_ADDITIONAL_SERVICE]: [...errorWorkflow({}, ERROR_CODES.CUSTOMER_NEEDS_ADDITIONAL_SERVICE)],
    },
  },
  [states.END_LOCATION]: {
    component: EndLocationProcess,
    meta: { stepper: { value: null } },
  },

  [states.RENTAL_EXTENSION_VEHICLE_LOCATION]: {
    component: RentalExtensionVehicleLocation,
    on: {
      [events.NEXT]: [
        {
          cond: (_, { payload }) => payload?.isVehicleInGarage === true,
          target: states.RENTAL_EXTENSION_DURATION,
        },
        {
          cond: (_, { payload }) => payload?.isVehicleInGarage === false,
          target: states.RENTAL_VEHICLE_OTHER_LOCATION,
        },
      ],
    },
  },

  [states.RENTAL_EXTENSION_CONFIRMATION]: {
    component: RentalExtensionConfirmation,
    on: {
      [events.NEXT]: {
        actions: [actions.coreApi.extendRentalMission],
      },
      [events.MODIFY]: {
        target: states.RENTAL_EXTENSION_DURATION,
      },
      [RENTAL_EXTENSION_SENT]: {
        actions: [actions.coreApi.searchMission, actions.coreApi.getClaimHistoryDispatch, actions.coreApi.getRentalCurrentLimits],
        target: states.RENTAL_SUMMARY,
      },
      [events.END]: {
        target: states.RENTAL_SUMMARY,
      },
      [REQUEST_ERROR]: {
        actions: [actions.error.setTechnicalError],
        target: states.VOICE_EXIT,
      },
    },
  },

  [states.RENTAL_EXTENSION_NOT_ELIGIBLE]: {
    component: RentalExtensionNotEligible,
    on: {
      [VIEW_TIMELINE]: {
        actions: [actions.coreApi.loadClaimById, actions.coreApi.searchMission, actions.rentalMission.clearIsExtensionFlow],
        target: states.PREVIOUS_CLAIM_HANDLING,
      },
    },
  },

  [states.RENTAL_EXTENSION_DURATION]: {
    component: RentalExtensionDuration,
    on: {
      [events.NEXT]: {
        actions: [actions.rentalMission.storeRentalExtensionDuration],
        target: states.RENTAL_EXTENSION_CONFIRMATION,
      },
      [events.END]: {
        target: states.RENTAL_SUMMARY,
      },
      [EXTENSION_DURATION_WEEKEND]: rentalExtensionClosedDayExit(ERROR_CODES.NEW_END_DATE_ON_A_WEEKEND),
      [EXTENSION_DURATION_BANK_HOLIDAY]: rentalExtensionClosedDayExit(ERROR_CODES.NEW_END_DATE_ON_A_BANK_HOLIDAY),
      [RENTAL_AGENCY_CLOSED]: rentalExtensionClosedDayExit(ERROR_CODES.RENTAL_AGENCY_CLOSED),
    },
  },

  [states.OEM_DECISION]: {
    component: OemDecisionPage,
    on: {
      [events.NEXT]: [
        {
          cond: (_, { payload }) => payload?.action === OEM_DECISION_ACTION.CONTACT_MANUFACTURER,
          actions: [actions.coreApi.transferToOem],
        },
        {
          cond: state => getBenefit(state),
          actions: [actions.coreApi.createOemRentalMission],
        },
        {
          actions: [actions.coreApi.createOemMission],
        },
      ],
      [OEM_TRANSFERRED]: {
        target: states.OEM_TRANSFERRED,
      },
      [MISSION_CREATED]: [
        {
          cond: shouldPutVehicleDestination,
          target: states.OEM_DECISION,
          actions: actions.coreApi.putVehicleDestination,
        },
        {
          target: states.CAR_DESTINATIONS,
          cond: state => isTOWService(state) && hasPossibleDestination(state),
        },
        {
          target: states.APPOINTMENT,
          cond: state => !getAppointmentDeactivation(state) && !isDigitalHighwayProcess(state),
        },
        {
          target: states.CONFIRMATION,
        },
      ],
      [MISSION_PUTTED]: [
        {
          cond: state =>
            (isTOWService(state) || isROSService(state)) &&
            hasPossibleDestination(state) &&
            !getAllowHidingDestinationProcessInDigital(state),
          target: states.CAR_DESTINATIONS,
        },
        {
          target: states.APPOINTMENT,
          cond: state => !getAppointmentDeactivation(state) && !isDigitalHighwayProcess(state),
        },
        {
          target: states.CONFIRMATION,
        },
      ],
      [REQUEST_ERROR]: [...errorWorkflow(CREATE_MISSION_ERROR)],
      [RENTAL_MISSION_CREATED]: [
        {
          cond: state => isVehicleImmobilizationOrVehicleDestinationAdded(state),
          target: states.RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM,
          actions: [actions.coreApi.clearSelectedBenefit],
        },
        {
          target: states.RENTAL_VEHICLE_OTHER_LOCATION,
          actions: [actions.coreApi.clearSelectedBenefit],
        },
      ],
    },
  },

  [states.OEM_TRANSFERRED]: {
    component: OemTransferredPage,
    meta: { stepper: { value: null } },
    type: 'final',
  },
};

const config = {
  key: 'drsa',
  computeInitialState,
  states: mainWorkflow,
};

export default config;
